import { isAuthenticatedSelector, KpkAutoComplete } from "@keepeek/commons";
import { selectorFamily } from "recoil";

import { getAxiosClientInstance } from "../../lib/axios/axios-utils";
import logger from "../../lib/logger-utils";
import { getAutocomplete } from "../../lib/search/search-autocomplete";

/**
 * Get autocomplete
 */
export const autocompleteSelector = selectorFamily<
  KpkAutoComplete[] | null,
  Readonly<{
    query: string;
    folderIds?: Array<number>;
    fieldIds?: Array<number>;
    limit?: number;
  }>
>({
  key: "AutocompleteSelector",
  get:
    ({ query, folderIds, fieldIds, limit }) =>
    async ({ get }) => {
      const isAuthenticated = get(isAuthenticatedSelector);
      if (!isAuthenticated) {
        logger.debug("AutocompleteSelector can't fetch without authentication");
        return null;
      }
      // Nothing to load
      if (!query) {
        return null;
      }
      try {
        // Get using API
        const result = await getAutocomplete(getAxiosClientInstance(), {
          query,
          folderIds,
          fieldIds,
          limit,
        });
        return result;
      } catch (error) {
        logger.warn("autocompleteSelector", error);
      }
      return null;
    },
});
